module.exports = __webpack_public_path__ + "static/media/915ty@4x.962f5d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/915ty@4x.png
// module id = 428
// module chunks = 0 1